// extracted by mini-css-extract-plugin
export default {"font-renta":"FormChecks_font-renta__PZa1Y","formChecks":"FormChecks_formChecks__8xLOc","title":"FormChecks_title__I13D8","check":"FormChecks_check__YgksS"};